// Keep upstream modules outside webpack: even their relative imports and
// query strings remain byte-for-byte identical to the supplied Phomymo ZIP.
const base = `${process.env.PUBLIC_URL || ''}/vendor/phomymo`;
let transportModule;
let printerModule;
let rendererModules;
let qrScript;

export function loadPhomymoTransport() {
  if (!transportModule) {
    transportModule = import(/* webpackIgnore: true */ `${base}/ble.js`)
      .catch(error => { transportModule = null; throw error; });
  }
  return transportModule;
}

function loadQrScript() {
  if (qrScript) return qrScript;
  qrScript = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${base}/qrcode-1.5.1.min.js`;
    script.onload = () => {
      if (typeof window.QRCode?.toCanvas === 'function') resolve();
      else { script.remove(); qrScript = null; reject(new Error('Libreria QR Phomymo non disponibile')); }
    };
    script.onerror = () => {
      script.remove(); qrScript = null;
      reject(new Error('Impossibile caricare la libreria QR Phomymo'));
    };
    document.head.appendChild(script);
  });
  return qrScript;
}

export function loadPhomymoPrinter() {
  if (!printerModule) {
    printerModule = import(/* webpackIgnore: true */ `${base}/printer.js`)
      .catch(error => { printerModule = null; throw error; });
  }
  return printerModule;
}

export function loadPhomymoRenderer() {
  if (!rendererModules) {
    rendererModules = Promise.all([
      import(/* webpackIgnore: true */ `${base}/canvas.js`),
      loadPhomymoPrinter(),
      loadQrScript(),
    ]).then(([canvas, printer]) => ({ ...canvas, ...printer }))
      .catch(error => { rendererModules = null; throw error; });
  }
  return rendererModules;
}
